export async function unwrap<T>(
  promise: Promise<{ data?: T }>,
): Promise<T> {
  const response = await promise;

  if (!('data' in response)) {
    throw new Error('Invalid response shape');
  }

  return response.data as T;
}
